import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import api from "../api";
import WorkspaceShell from "./WorkspaceShell";

const sections = [
  { label: "Overview", items: [
    { title: "Dashboard", path: "/home", icon: "grid" },
    { title: "Needs Attention", path: "/admin/needs-attention", icon: "alert" },
  ]},
  { label: "Your portfolio", items: [
    { title: "List Properties", path: "/list-properties", icon: "home" },
    { title: "View Properties Map", path: "/map-properties", icon: "pin" },
    { title: "Tenant List", path: "/admin/tenants", icon: "people" },
    { title: "Leads Inbox", path: "/admin/leads", icon: "message" },
  ]},
  { label: "Operations", items: [
    { title: "Payments", path: "/payments", icon: "wallet" },
    { title: "Payment Statements", path: "/admin/payment-statements", icon: "document" },
    { title: "Reports", path: "/admin/reports", icon: "document" },
    { title: "Reminder Center", path: "/admin/reminders", icon: "clock" },
  ]},
  { label: "Communication", items: [
    { title: "Messages", path: "/admin/messages", icon: "message" },
    { title: "Action Logs", path: "/admin/notifications", icon: "bell" },
    { title: "Announcements", path: "/admin/announcements", icon: "bell" },
  ]},
  { label: "Records", items: [
    { title: "Activity Timeline", path: "/admin/activity", icon: "clock" },
    { title: "Archive Center", path: "/admin/archive-center", icon: "archive" },
  ]},
];

export default function AdminLayout({ children, onLogout }) {
  const navigate = useNavigate();
  const [username, setUsername] = useState(localStorage.getItem("username") || "Admin");
  const [loadingUser, setLoadingUser] = useState(true);
  useEffect(() => {
    let active = true;
    const token = localStorage.getItem("token");
    if (!token) { navigate("/"); return; }
    api.get("/user").then(({ data }) => {
      if (!active) return;
      const name = data.name || data.username || "Admin";
      setUsername(name);
      localStorage.setItem("username", name);
    }).catch(() => {
      if (!active) return;
      localStorage.clear();
      if (onLogout) onLogout();
      navigate("/");
    }).finally(() => { if (active) setLoadingUser(false); });
    return () => { active = false; };
  }, [navigate, onLogout]);
  const handleLogout = () => {
    localStorage.clear();
    if (onLogout) onLogout();
    navigate("/");
  };
  if (loadingUser) return <div className="workspace-theme ws-loading" role="status">Opening your workspace…</div>;
  return <WorkspaceShell sections={sections} username={username} role="Admin" onLogout={handleLogout}>{children || <Outlet />}</WorkspaceShell>;
}
